import React from 'react'
import client from  './images/client.png';


export default function () {
  return (
    <div>
        <section id="client" className=" mt-5 mb-5 container">
  <h2 className="mt-5 mb-5  ">Client Testimonials</h2>
  <div className="d-flex justify-content-center flex-column align-items-center  gap-3">
    <img src={client} alt="Jhone Walker Hussy" />
    <h3>Jhone Walker Hussy</h3>
    <ul className="list-unstyled d-flex ">
      <li>
        <i className="fa-solid fa-star text-warning fs-5" />
      </li>
      <li>
        <i className="fa-solid fa-star text-warning fs-5" />
      </li>
      <li>
        <i className="fa-solid fa-star text-warning fs-5" />
      </li>
      <li>
        <i className="fa-solid fa-star text-warning fs-5" />
      </li>
      <li>
        <i className="fa-solid fa-star text-warning fs-5" />
      </li>
    </ul>
    <p className="">
      Quote testimonials are ads or artwork that display positive statements
      about your company from a brand evangelist or a delighted customer. The
      quote is usually accompanied by an image.
    </p>
    <div id="client-btn">
      <button className="btn btn-outline-success client-button">
        <i className="fa-solid fa-arrow-left" />
      </button>
      <button className="btn btn-outline-success client-button">
        <i className="fa-solid fa-arrow-right" />
      </button>
    </div>
  </div>
</section>

    </div>
  )
}
